import { MatriculaAlunoSchema } from "@/schema/matriculaAlunoSchema";
import Logomarca from "@/assets/images/Logo.png";
import WhatsappIcon from "@/assets/images/whatsapp.png";
import { mascaraCelular, mascaraCnpj, mascaraCpf, mascaraMatricula } from '@/utils/masks';
import Cambria from "@/assets/fonts/Cambria.ttf";
import CambriaBold from "@/assets/fonts/Cambria_Bold.ttf";
import 'moment/locale/pt-br';
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    PDFViewer,
    Image,
    Font
} from "@react-pdf/renderer";
import moment from 'moment';

moment.locale('pt-br');

// const { Title } = Typography;
Font.register({
    family: 'Cambria',
    fonts: [
        {
          src: Cambria,
        },
        {
          src: CambriaBold,
          fontWeight: 'bold',
        }
      ],
  });

interface AulaDto {
    diaSemana: string;
    especificaId: number;
    especificaNome: string;
}

interface HorarioDto {
    id: number;
    grupo: string;
    ordem: number;
    horaInicio: string;
    horaFim: string;
    aulas: AulaDto[];
}

interface GradeHorariaDetalhe {
    id: number;
    turmaId: number;
    turmaNome: string;
    turmaPeriodoLetivoDataInicio: string;
    turmaPeriodoLetivoDataFim: string;
    unidadeId: number;
    unidadeNome: string;
    ativo: boolean;
    horarios: HorarioDto[];
}

interface ContratoProps {
    matriculaAluno: MatriculaAlunoSchema;
    gradeHoraria?: GradeHorariaDetalhe;
}

export const Contrato = ({ matriculaAluno, gradeHoraria }: ContratoProps) => {

    const getDisciplinas = () => {
        return matriculaAluno.disciplinas.map(obj => obj.nome).join(', ');
    };

    const styles = StyleSheet.create({
        page: {
            backgroundColor: "#ffffff",
            color: "black",
            padding: 20,
            paddingBottom: 35,
        },
        section: {
            backgroundColor: "#ffffff",
            color: "black",
            margin: 10,
            padding: 10,
            textAlign: "justify",
            lineHeight: 1
        },
        logo: {
            backgroundColor: "#ffffff",
            color: "black",
            alignSelf: "center",
            height: 60,
            width: 164,
            marginBottom: 10,
        },
        title: {
            color: "black",
            fontWeight: "bold",
            fontSize: 12,
            alignSelf: "center",
            fontFamily: 'Cambria',
        },
        row: {
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        textnegrito: {
            color: "black",
            fontWeight: "bold",
            fontSize: 12,
            fontFamily: 'Cambria',
        },
        textnormal: {
            color: "black",
            fontSize: 12,
            fontFamily: 'Cambria',
            marginBottom: 10,
        },
        dataFinalContrato: {
            color: "black",
            fontSize: 12,
            fontFamily: 'Cambria',
            textAlign: 'right',
            marginTop: 30,
        },
        signatureLine: {
          marginTop: 40,
          textAlign: 'center',
        },
        signatureName: {
          marginTop: 5,
          textAlign: 'center',
          fontSize: 12,
          fontFamily: 'Cambria',
        },
        viewer: {
            width: window.innerWidth / 1.3, //the pdf viewer will take up all of the width and height
            height: window.innerHeight / 1.3,
        },
        tableTitle: {
            color: 'black',
            fontWeight: 'bold',
            fontSize: 13,
            alignSelf: 'center',
            fontFamily: 'Cambria',
            marginBottom: 12,
            marginTop: 10,
        },
        tableContainer: {
            margin: 10,
            borderWidth: 1,
            borderColor: '#000',
        },
        tableHeaderRow: {
            flexDirection: 'row',
            backgroundColor: '#d0d0d0',
            borderBottomWidth: 1,
            borderBottomColor: '#000',
        },
        tableRow: {
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderBottomColor: '#ccc',
        },
        tableHeaderCell: {
            flex: 1,
            padding: 5,
            fontSize: 10,
            fontFamily: 'Cambria',
            fontWeight: 'bold',
            borderRightWidth: 1,
            borderRightColor: '#000',
            color: 'black',
        },
        tableCell: {
            flex: 1,
            padding: 5,
            fontSize: 10,
            fontFamily: 'Cambria',
            borderRightWidth: 1,
            borderRightColor: '#ccc',
            color: 'black',
        },
        footer: {
            position: 'absolute',
            bottom: 12,
            left: 20,
            right: 20,
            textAlign: 'right',
            fontSize: 10,
            fontFamily: 'Cambria',
            color: 'black',
        },
        gradeTable: {
            marginHorizontal: 10,
            marginBottom: 6,
            borderWidth: 1,
            borderColor: '#000',
        },
        gradeHeaderRow: {
            flexDirection: 'row',
            backgroundColor: '#d0d0d0',
            borderBottomWidth: 1,
            borderBottomColor: '#000',
        },
        gradeHeaderCell: {
            flex: 1,
            padding: 4,
            fontSize: 8,
            fontFamily: 'Cambria',
            fontWeight: 'bold',
            borderRightWidth: 1,
            borderRightColor: '#000',
            color: 'black',
            textAlign: 'center',
        },
        gradeCellHorario: {
            flex: 0.9,
        },
        gradeGroupRow: {
            backgroundColor: '#e8e8e8',
            borderBottomWidth: 1,
            borderBottomColor: '#ccc',
            padding: 3,
            paddingLeft: 6,
        },
        gradeGroupLabel: {
            fontSize: 8,
            fontFamily: 'Cambria',
            fontWeight: 'bold',
            color: 'black',
        },
        gradeRow: {
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderBottomColor: '#ccc',
        },
        gradeRowEven: {
            backgroundColor: '#fafafa',
        },
        gradeCell: {
            flex: 1,
            padding: 4,
            borderRightWidth: 1,
            borderRightColor: '#ccc',
        },
        gradeCellText: {
            fontSize: 7,
            fontFamily: 'Cambria',
            color: 'black',
            textAlign: 'center',
        },
        gradePhoneFooter: {
            marginTop: 20,
            marginLeft: 10,
        },
    });

    const getValorTotal = () => {
        let valorTotal = matriculaAluno.pagamentos.reduce(function (a, v) {return a + (v.valor || 0)}, 0);
        return valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }

    const getDataLimiteCancelamento = () => {
        let limiteDias = moment(matriculaAluno.dataFimAula).diff(moment(matriculaAluno.dataInicioAula), 'days') / 2;
        return moment(matriculaAluno.dataInicioAula).add(limiteDias, 'days').format('DD [de] MMMM [de] YYYY');
    }

    const getDataContrato = (data: Date) => {
        return moment(data).format('DD [de] MMMM [de] YYYY');
    }

    const possuiCabineEstudoVIP = () => {
        return matriculaAluno.disciplinas.some(d => d.nome === "Cabine VIP");
    }

    const possuiCheques = () => {
        return (matriculaAluno.cheques?.length ?? 0) > 0;
    }

    // Os cheques não guardam data/valor próprios: cada cheque é vinculado, na ordem,
    // à parcela de pagamento do tipo Cheque de mesmo índice (mesma regra do backend).
    const getParcelasCheque = () => {
        return [...(matriculaAluno.pagamentos ?? [])]
            .filter(p => p.pagamento?.tipoPagamento === 'Cheque')
            .sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
    }

    const getChequesOrdenados = () => {
        return [...(matriculaAluno.cheques ?? [])].sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
    }

    const getChequeDatas = (): string[] => {
        const parcelasCheque = getParcelasCheque();

        return getChequesOrdenados().map((_, i) => {
            const data = parcelasCheque[i]?.dataParcela;
            return data ? moment(data).format('DD/MM/YYYY') : '';
        });
    }

    const getChequeValores = (): string[] => {
        const parcelasCheque = getParcelasCheque();

        return getChequesOrdenados().map((_, i) => {
            const valor = parcelasCheque[i]?.valor;
            return valor !== undefined && valor !== null
                ? valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                : '';
        });
    }

    const getValorCabine = () => {
        return matriculaAluno.valorCabineVip?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }

    const DIAS_ORDER = ['Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];
    const DIAS_LABELS: Record<string, string> = {
        Segunda: 'Segunda', Terca: 'Terça', Quarta: 'Quarta',
        Quinta: 'Quinta', Sexta: 'Sexta', Sabado: 'Sábado',
    };
    const GRUPO_ORDER = ['Manha', 'Tarde', 'Noite'];
    const GRUPO_LABELS: Record<string, string> = { Manha: 'Manhã', Tarde: 'Tarde', Noite: 'Noite' };

    const getAlunoEspecificaIds = (): Set<number> => {
        return new Set(
            (matriculaAluno.disciplinas ?? [])
                .filter(d => d.codEspecificaServico?.startsWith('E') && d.disciplinaId != null)
                .map(d => d.disciplinaId!)
        );
    };

    const getEspecificasSemGrade = () => {
        if (!gradeHoraria) return [];
        const allGradeIds = new Set<number>(
            gradeHoraria.horarios.flatMap(h => h.aulas.map(a => a.especificaId))
        );
        return (matriculaAluno.disciplinas ?? []).filter(
            d => d.codEspecificaServico?.startsWith('E') && d.disciplinaId != null && !allGradeIds.has(d.disciplinaId!)
        );
    };

    return (
        <>
            <PDFViewer style={styles.viewer}>
                {/* Start of the document*/}
                <Document>
                    {/*render a single page*/}
                    <Page size="A4" style={styles.page}>
                        <View style={styles.logo}>
                            <Image src={Logomarca} />
                        </View>
                        <View style={styles.title}><Text>Contrato para Prestação de Serviços de Administração de Atividades Educacionais</Text></View>
                        <View style={styles.section}>
                            <View style={styles.row}>
                                    <Text>
                                        <Text style={styles.textnegrito}>Aluno: </Text>
                                        <Text style={styles.textnormal}>{matriculaAluno.estudante?.pessoaEstudante?.nome ?? ''} </Text>
                                    </Text>
                                    <Text>
                                        <Text style={styles.textnegrito}>Contrato n.º: </Text>
                                        <Text style={styles.textnormal}>{mascaraMatricula(matriculaAluno.matricula ? matriculaAluno.matricula.toString() : "")}</Text>
                                    </Text>
                            </View>
                            <Text>
                                <Text style={styles.textnegrito}>Turma contratada: </Text>
                                <Text style={styles.textnormal}>{matriculaAluno.turmaNome}</Text>
                            </Text>
                            <Text>
                                <Text style={styles.textnegrito}>Curso(s) contratado(s): </Text>
                                <Text style={styles.textnormal}>{getDisciplinas()}</Text>
                            </Text>
                            <Text>
                                <Text style={styles.textnegrito}>Contratante: </Text>
                                <Text style={styles.textnormal}>{matriculaAluno.responsavel.pessoaResponsavel.nome}</Text>
                            </Text>
                            <Text>
                                <Text style={styles.textnegrito}>CPF/MF: </Text>
                                <Text style={styles.textnormal}>{mascaraCpf(matriculaAluno.responsavel.pessoaResponsavel.cpfCnpj ?? '')}</Text>
                            </Text>
                            <Text>
                                <Text>
                                    <Text style={styles.textnegrito}>RG: </Text>
                                    <Text style={styles.textnormal}>{matriculaAluno.responsavel.pessoaResponsavel.rg}    </Text>
                                </Text>
                                <Text>
                                    <Text style={styles.textnegrito}>Órgão Expedidor: </Text>
                                    <Text style={styles.textnormal}>{matriculaAluno.responsavel.pessoaResponsavel.orgaoEmissorRg}/{matriculaAluno.responsavel.pessoaResponsavel.ufRg}</Text>
                                </Text>
                            </Text>
                            <Text>
                                <Text style={styles.textnegrito}>Endereço: </Text>
                                <Text style={styles.textnormal}>{matriculaAluno.responsavel.pessoaResponsavel.logradouro} {matriculaAluno.responsavel.pessoaResponsavel.numero} {matriculaAluno.responsavel.pessoaResponsavel.complemento}</Text>
                            </Text>
                            <Text>
                                <Text style={styles.textnegrito}>Telefones de contato: </Text>
                                <Text style={styles.textnormal}>{mascaraCelular(matriculaAluno.responsavel.pessoaResponsavel.celular)} / {mascaraCelular(matriculaAluno.responsavel.pessoaResponsavel.telefone)}</Text>
                            </Text>
                            <Text>
                                <Text style={styles.textnegrito}>E-mail: </Text>
                                <Text style={styles.textnormal}>{matriculaAluno.responsavel.pessoaResponsavel.email}</Text>
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>Nome do(a) Responsável legal e(ou) financeiro: </Text>
                                <Text style={styles.textnormal}>{matriculaAluno.responsavel.pessoaResponsavel.nome}</Text>
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>Contratada: ACADEMIA DAS ESPECÍFICAS - GESTÃO EDUCACIONAL LTDA</Text>
                                <Text style={styles.textnormal}>, pessoa coletiva portadora do
                                CNPJ {mascaraCnpj(matriculaAluno.unidade?.cnpj ?? "")}, com sede sito à {matriculaAluno.unidade?.enderecoCompleto}, 
                                presentada pelo senhor {matriculaAluno.unidade?.responsavel ?? ""}, brasileiro, casado, 
                                portador do CPF {mascaraCpf(matriculaAluno.unidade?.responsavelCpf ?? "")} e 
                                RG {matriculaAluno.unidade?.rg} {matriculaAluno.unidade?.orgaoRg}, com 
                                domiciliado no mesmo endereço da Contratada, telefone de contato: {mascaraCelular(matriculaAluno.unidade?.telefone ?? "")}, 
                                e-mail: {matriculaAluno.unidade?.email}.
                                </Text>
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>Preâmbulo.</Text> Pelo presente instrumento Contratante e Contratada retrocitados(as) celebram o
                                presente <Text style={styles.textnegrito}>CONTRATO DE PRESTAÇÃO DE SERVIÇOS EDUCACIONAIS NA MODALIDADE DE ENSINO
                                    PRESENCIAL E/OU À DISTÂNCIA</Text>, que será regido pelos arts. 206, II e III, e 209 da Constituição Federal de
                                1988 (CF/88) e nas disposições das Leis nº 8.078, de 11 de setembro de 1990 (Código de Defesa do
                                Consumidor), da Lei n.º 10.406, de 10 de janeiro de 2002 (Código Civil), entre outras legislações aplicáveis
                                a este contrato, bem como pelas condições gerais contratuais (CGC) abaixo elencadas.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 1 - OBJETO DO CONTRATO.</Text> O objeto deste contrato é a prestação de serviços sem subordinação da
                                Contratada em relação ao(à) Contratante, de administração do curso preparatório para vestibulares
                                escolhido pela Contratante, a ser ministrado por docentes autorizados pela Contratada, mediante
                                remuneração a ser adimplida pelo(a) Contratante.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO ÚNICO. </Text> O(a) responsável financeiro pelo Contratante não poderá ser substituído na vigência
                                deste Contrato, exceto na ocorrência de eventos como falecimento ou insolvência ou possibi- lidade de
                                insolvência, quando a substituição poderá ocorrer mediante requerimento formal da parte Contratante e
                                condicionado à aceitação expressa por escrito da Contratada.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 2 - TEMPO DO CONTRATO.</Text> Este contratado se iniciará em <Text style={styles.textnegrito}>{getDataContrato(matriculaAluno.dataInicioAula ?? new Date)}</Text> e 
                                terminará em <Text style={styles.textnegrito}>{getDataContrato(matriculaAluno.dataFimAula ?? new Date)}</Text>, podendo ter o seu tempo majorado, caso haja necessidade extraordinária,
                                principalmente com a alteração de datas no(s) vestibular(es) que o curso contratado abarca(m).
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 3 - VALOR DO CONTRATO.</Text> Pelo(s) curso(s) contratado(s), a parte Contratante e (ou) quem for o(a)
                                seu(sua) responsável financeiro, de forma solidária (CC, art. 275), pagará o valor de {getValorTotal()} ({matriculaAluno.valorTotalExtenso ? matriculaAluno.valorTotalExtenso.toLowerCase() : ""}), 
                                cujo pagamento será feito por: {matriculaAluno.formasPagamento}.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO - ATRASO NO PAGAMENTO E PROVIDÊNCIAS DA CONTRATADA. Em caso de
                                    inadimplemento do valor contratado, seja ele a ser adimplido à vista ou de forma parcelada, haverá
                                    a cobrança de multa de 2% (dois por cento) sobre o valor integral devido ou de cada parcela
                                    devida, juros de mora de 1% (um por cento) ao mês ou fração de mês e atualização mo- netária pelo
                                    índice INPC e equivalente ou substituto se este índice for extinto, bem como poderá adotar todas as
                                    providências legais de cobrança cabíveis, inclusive, pedir a inscrição do nome da parte
                                    CONTRATANTE e (ou) de quem seja seu ou sua responsável financeiro em cadastro ou em serviços
                                    legalmente constituídos e destinados à proteção da cobrança do crédito advindo deste contrato,
                                    valendo o presente contrato como título executivo extrajudicial, nos termos do art. 784, III, do
                                    Código de Processo Civil (CPC), reconhecendo, a parte Contratante, desde já, este título, como
                                    líquido, certo e exigível, ou, ainda, qualquer tipo de cobrança prevista na le- gislação brasileira,
                                    independentemente de prévia notificação judicial ou extrajudicial, podendo tais providências
                                    serem tomadas isolada, gradativa ou cumulativamente.</Text>
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO SEGUNDO - CONSEQUÊNCIAS DO PAGAMENTO POR CHEQUE. Qualquer pagamento feito
                                    por meio de cheque de valores, de qualquer ordem, devidos pela parte Contratante à Contratada
                                    somente serão considerados efetivamente quitados após a compensação deste, não obstante a
                                    autenticação do aviso de cobrança. A devolução de cheque importará na cobrança da multa
                                    prevista no parágrafo primeiro desta CGC.</Text>
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 4 -CANCELAMENTO DE MATRÍCULA.</Text> O cancelamento de matrícula é o único ato eficaz para
                                suspender a cobrança do valor devido pela parte Contratante à Contratada, cuja composição quanto à
                                devolução de parte do valor pago ou de sua integralidade dependerá do prazo que resta para o término
                                do contrato.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO - CANCELAMENTO E ADIMPLÊNCIA DA PARTE CONTRATANTE.</Text> Para efetivar o
                                cancelamento de matrícula, a parte Contratante deverá estar adimplente com o valor devido até a data da
                                respectiva solicitação ou, alternativamente, firmar um Instrumento de Confissão de Dívida, reconhecendo
                                o seu débito, se ainda não vencido o seu prazo de pagamento, ou a obrigação de pagar se já vencido o
                                prazo de pagamento do débito, para com a Contratada e acordando a forma de pagamento deste débito.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO SEGUNDO - AUSÊNCIA DE DEVOLUÇÃO DOS VALORES ADIMPLIDOS.</Text> A parte Contratante
                                que requerer o cancelamento de matrícula não terá, em nenhuma hipótese e sob nenhum fundamento,
                                direito à devolução dos valores pagos até a data da apresentação do pedido de cancelamento, visto que
                                tais pagamentos remuneraram a serviços já prestados e custos já incorridos pela Contratada.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO TERCEIRO - ENVIO DE PUBLICIDADE PELA CONTRATADA À PARTE CONTRATANTE.</Text>
                                Dentro de padrões aceitáveis e seguindo as melhores práticas de mercado, a Contratada poderá incluir
                                publicidade no seu sítio eletrônico ou enviar e-mails com publicidade, sem que isso, contudo pre- judique o
                                aprendizado dos alunos ou degrade a qualidade de seus cursos.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO QUARTO - PROCEDIMENTO A SER REALIZADO PELA PARTE CONTRATANTE CASO NÃO
                                    QUEIRA RECEBER PUBLICIDADE DA CONTRATADA.</Text> Caso a parte Contratante não queira receber tal
                                publicidade deve informar por escrito em meio eletrônico ou impresso ou manual à Contratada no
                                momento da assinatura do contrato. O silêncio da parte Contratante quanto ao referido recebimento de
                                publicidade será interpretado como aceitação de recebê-la na forma do parágrafo quarto desta CGC.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 5 - DESCRIÇÃO DO SERVIÇO.</Text> A Contratada disponibiliza profissionais responsáveis para ministrar o
                                ensino preparatório para concursos vestibulares contratado pelo(a) Contratante, por meio de aulas
                                presenciais e/ou à distância e de outras atividades de aprendizado, <Text style={styles.textnegrito}>vigente para o ano de {matriculaAluno.matricula?.toString().substring(1,5)}</Text>.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO</Text> - A parte contratante deverá tratar questões pedagógicas e de críticas positivas
                                ou negativas, primeiramente, com o(a) Docente que ministra o Curso Contratado. Caso eventual problema
                                não seja resolvido, pode a parte Contratante informar o problema à Contratada, que envidará esforços
                                para solucioná-lo de forma mais rápida possível.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO SEGUNDO - EVENTUAIS ALTERAÇÕES REALIZADAS PELA CONTRATADA.</Text> A Contratada pode
                                realizar alterações para adequar a prestação do serviço contratado diante de necessidade pedagógica e
                                (ou) logística devidamente informada à parte Contratante e ao(à) seu ou sua responsável ou assistente
                                jurídico, nos casos de o(a) Contratante estar com idade inferior aos 18 (dezoito) anos no momento da
                                conclusão (início) deste Contrato.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO TERCEIRO - MODALIDADE DE ENSINO.</Text> A Contratada ministrará prioritariamente o curso na
                                modalidade presencial, mas também se resguarda no direito de o ministrar em sua totalidade ou em parte
                                dele de forma à distância sempre que houver um decreto governamental inviabilizando o acesso
                                presencial, se houver algum impedimento na estrutura predial que coloque em risco a saúde dos
                                ocupantes ou caso haja alguma calamidade que torne inviável a prestação do serviço na modalidade
                                presencial.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 6 - CONDIÇÕES PEDAGÓGICO LOGÍSTICAS OFERTADAS PELA CONTRATADA.</Text> A Contratada oferece
                                instalações e equipamentos relativos ao desenvolvimento da atividade docente, pessoal docente e
                                administrativo, material didático, sendo as aulas concentradas no turno estabelecido para a(s) turma(s)
                                selecionada(s) pelo(a) Contratante, podendo ocorrer convocação do(a) Contratante para assistir aulas
                                extras em outros turnos de acordo com as necessidades do calendário e do volume de conteúdo.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO ÚNICO</Text> - A parte contratada poderá alterar os horários dos cursos contratados, bem como
                                os profissionais que irão ministrá-lo, desde que isso ocorra num mesmo turno do dia e por profissionais
                                com conhecimento comprovado na área, sem que tais fatos deem ensejo a qualquer tipo de indenização,
                                descontos e qualquer tipo de ressarcimento de danos, sejam eles de que natureza for.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 7 - INÍCIO DAS AULAS.</Text> O início das aulas ocorrerá no dia {getDataContrato(matriculaAluno.dataInicioAula ?? new Date)} e seu término ocorrerá
                                dia {getDataContrato(matriculaAluno.dataFimAula ?? new Date)}. A data de término pode ser alterada de acordo com o calendário de provas,
                                a critério da Contratada.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 8 - DIFERENÇA ENTRE OS CURSOS OFERTADOS PELA CONTRATADA.</Text> A parte Contratante declara ter
                                conhecimento de que as atividades de cada CURSO são atividades independentes, ou seja, não há a
                                obrigatoriedade do(s) curso(s) contratados fornecerem os mesmos serviços adicionais. <Text style={styles.textnegrito}>Curso(s): {getDisciplinas()}</Text>.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 9 - SERVIÇOS ADICIONAIS.</Text> Caso a parte Contratante contrate os serviços adicionais tais como, <Text style={styles.textnegrito}>USO
                                    ONEROSO DA CABINE VIP DE ESTUDOS ou ORIENTAÇÃO DE ESTUDOS</Text>, a descrição desse(s) estará(ão) anexa(s)
                                a esse contrato caso seja contratado(s) concomitantemente a este contrato ou em ADITIVO CONTRATUAL,
                                se contratado em momento posterior à data de início deste contrato.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 10 - AUSÊNCIA DE COMPARECIMENTO DA PARTE CONTRATANTE NAS AULAS DO CURSO
                                    CONTRATADO.</Text> O não comparecimento da parte Contratante às aulas ora contratadas não exime o
                                pagamento, tendo em vista que o serviço está à sua disposição.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO ÚNICO.</Text> Os pagamentos referentes ao(s) curso(s) se realizados de forma parcelada ou à vista
                                não se tratam de mensalidade, e, no caso de parcelamento do valor contratado, pode, dependendo de seu
                                número, ter seus vencimentos numa data posterior ao término dos serviços contratados.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 11 - FORMAS DE EXTINÇÃO DA RELAÇÃO CONTRATUAL.</Text> As partes procurarão compor os conflitos
                                contratuais para que se evite o término da relação contratual, sendo que este término ocorrerá de forma
                                natural se houver o adimplemento integral do valor a ser pago pela parte Contratante conjugado com o
                                término do período temporal do contrato. Afora essas duas hipóteses, a relação contratual pode se
                                extinguir pelas modalidades abaixo:
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO - POSSIBILIDADE DE INSCRIÇÃO DO NOME DA PARTE CONTRATANTE EM
                                    ÓRGÃO DE CRÉDITO.</Text> A parte Contratante tem ciência, neste ato, de que, em caso de inadimplência das
                                parcelas ou do valor do contrato na data aprazada por 30 (trinta) dias ou mais, será este fato comunicado
                                ao(s) órgão(s) e/ou serviço(s) de Proteção ao Crédito, legalmente existente para registro, nos termos do
                                art. 43 do CDC.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO SEGUNDO - RESOLUÇÃO DA RELAÇÃO CONTRATUAL.</Text> Havendo inadimplência total ou
                                parcial das CGC deste contrato por qualquer das partes, pode aquela que está adimplente utilizar os arts.
                                475-477 do CC e pedir a <Text style={styles.textnegrito}>resolução da relação contratual</Text>, com a cobrança da cláusula penal no
                                percentual de 30% (trinta por cento) do valor do contrato e, comprovado prejuízo suplementar, pedir a
                                sua reparação, na forma do art. 416 do CC.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO TERCEIRO - RETENÇÃO DO VALOR PAGO.</Text> O percentual de retenção do valor já adimplido
                                pela parte Contratante em favor da Contratada ou o não pagamento das parcelas vincendas, em caso de
                                pagamento do valor do contrato de forma parcelada será discutido com a parte Contratante, a partir da
                                análise do comportamento contratual ao longo da relação ente as partes.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO QUARTO - RESILIÇÃO UNILATERAL OU BILATERAL PELAS PARTES.</Text> As partes podem
                                resilir a relação contratual de forma unilateral, desde que avise a outra parte por escrito impresso ou em
                                meio eletrônico nos e-mails informados neste contrato, da seguinte maneira:
                            </Text>
                            <Text style={styles.textnormal}>
                                a) <Text style={styles.textnegrito}>Até 15 (quinze) dias</Text>, a contar do início das aulas, será cobrado um valor 
                                de R$ 460,00 (quatrocentos e sessenta reais), referente à taxa de matrícula. 
                                Também será cobrado um valor de R$ 300,00 (trezentos reais) por cada curso cancelado, 
                                referente à taxa de material. Caso seja cancelado Humanidades, será cabrado um valor adicional de 
                                R$ 300,00 (trezentos reais) referente a uma apostila extra e, caso seja cancelado Português ou Redação, 
                                será cobrado um outro valor adicional de R$ 300,00 (trezentos reais) referente ao planner, 
                                a exceção de Filosofia e Sociologia, em que a taxa desse material é de R$ 150,00 (cento e cinquenta reais).
                            </Text>
                            <Text style={styles.textnormal}>
                                b) <Text style={styles.textnegrito}>Após 15 (quinze) dias</Text>, a contar do início das aulas, e até o dia {getDataLimiteCancelamento()}, fica a parte
                                Contratante de forma solidária com quem for seu responsável financeiro a pagar os valores descritos na
                                <Text style={styles.textnegrito}> alínea a</Text> acrescidos do valor proporcional às semanas compreendidas entre a data do pedido formal de
                                cancelamento e a data do início do(s) curso(s) ou assinatura do contrato, o que ocorrer por último,
                                acrescidos também de multa penitencial no valor de 25% (vinte e cinco por cento) do valor relativo às
                                semanas a serem ministradas, ou seja, compreendidas entre o pedido formal de cancelamento e a data de
                                término estipulada nesse contrato.
                            </Text>
                            <Text style={styles.textnormal}>
                                c) <Text style={styles.textnegrito}>Após {getDataLimiteCancelamento()}</Text>, não será permitido o cancelamento contratual, sob pena de ter que pagar
                                o contrato em sua integralidade.
                            </Text>
                            <Text style={styles.textnormal}>
                                d) Os valores resilitórios incidirão sobre o valor líquido praticado no contrato, conforme descitos nas
                                alíneas a e b.
                            </Text>
                            <Text style={styles.textnormal}>
                                e) Caso ambas as partes acordem resilir bilateralmente, seguem com as mesmas consequências da resilição
                                unilateral postas neste parágrafo.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO QUINTO - MORTE DA PARTE CONTRATANTE.</Text> Em caso de morte da parte Contratante, os
                                seus herdeiros, até o limite do quinhão que receberem de herança, deverão pagar o valor vencido e,
                                eventualmente, inadimplido, liberando-se do pagamento de eventuais parcelas vincendas, na forma do art.
                                597 do CC.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 12 - CARTÃO DE ACESSO FORNECIDO PELA CONTRATADA À PARTE CONTRATANTE.</Text> A Contratada
                                fornecerá sem nenhum ônus à parte Contratante um cartão de acesso às dependências do local onde os
                                serviços serão prestados que, não necessariamente, terá validade como identidade estudantil. Este cartão é
                                de posse obrigatória e somente por meio de sua utilização dar-se-á o acesso aos serviços a serem
                                prestados. Caso a parte Contratante, por quaisquer motivos, venha a não mais possuir o cartão, a
                                Contratada providenciará a fabricação de outro mediante o pagamento de uma taxa de R$ 20,00 (vinte
                                reais) pela parte Contratante.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO ÚNICO.</Text> Caso o cartão de acesso venha ou esteja com problemas para uso sem que a parte
                                Contratante tenha dado causa ao problema, a Contratada realizará a substituição do cartão de acesso sem
                                ônus para a parte Contratante.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 13. POSSÍVEIS DESCONTOS CONFERIDOS PELA CONTRATADA À PARTE CONTRATANTE.</Text> A
                                Contratada poderá conceder desconto à parte Contratante mediante critérios estabelecidos previamente
                                por ela e mediante pedido por escrito pela parte Contratante, que será analisado e deferido, deferido em
                                parte ou indeferido pela Contratada em até 5 (cinco) dias úteis, contados do dia do pedido de desconto.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO. Em caso de falta de pagamento no vencimento, a parte Contratante perderá
                                    eventuais descontos concedidos pela Contratada, e o valor vencido será acrescido de juros de mora
                                    de 1% (um por cento ao mês) e correção monetária pelo INPC.</Text>
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO SEGUNDO.</Text> Em caso de bolsa, o Contratante deverá assinar um termo de compromisso, a
                                partir do qual a descrição deste estará anexa a esse contrato.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 14 - VALORES EXCLUÍDOS DESTE CONTRATO.</Text> Excluem-se do presente contrato todo e qualquer
                                valor relativo a serviços extraordinários efetivamente prestados à parte Contratante pela Contratada, tais
                                como: shows, viagens, excursões, transporte, material didático complementar (cadernos, lápis, borracha,
                                etc.) e todas as atividades extras optativas que originalmente não componham os cursos descritos na CGC
                                8.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 15 - RESPONSABILIDADE EXCLUSIVA DA CONTRATADA PELA ORIENTAÇÃO TÉCNICA:</Text> É de inteira e
                                exclusiva responsabilidade da Contratada, a orientação técnica sobre a prestação dos serviços de aula, no
                                que se refere ao calendário de datas para simulados, aulas extras, caso necessário, além de outras
                                providências que as atividades docentes exigirem, obedecendo ao seu critério, sem ingerência da parte
                                Contratante.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO ÚNICO.</Text> As aulas serão ministradas nas salas de aula ou locais que a Contratada indicar,
                                tendo em vista a natureza do conteúdo e da técnica pedagógica que se fizerem necessárias. A parte
                                Contratante declara ter conhecimento de que as salas de aula podem ser climatizadas com ar condicionado
                                e (ou) ventilador(es).
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 16 - NÚMERO MÍNIMO DE DISCENTES EM CADA TURMA.</Text> A Contratada se resguarda ao direito de
                                somente fazer funcionar turmas com o número mínimo de 30 (trinta) discentes. Caso não se alcance esse
                                número, fica a cargo dos professores responsáveis pelo curso contratado a não abertura da turma e, neste
                                caso, a restituição integral à parte Contratante do valor pago pelo respectivo curso.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 17. USO DA IMAGEM DA PARTE CONTRATANTE.</Text> A parte contratante, por meio deste contrato,
                                autoriza <Text style={styles.textnegrito}>pelo período de até dezoito meses da primeira inserção publicitária</Text> o uso de sua imagem
                                feita pela Contratada <Text style={styles.textnegrito}>ou por seus parceiros conveniados</Text>, para divulgação dos resultados obtidos nos
                                concursos vestibulares, em todos os veículos de comunicação (escrita, falada e televisiva) e publicidade
                                (outdoor’s, banner’s, folhetos, internet, redes sociais, etc.), <Text style={styles.textnegrito}>não cabendo qualquer indenização e (ou)
                                compensação pecuniária ou de outra ordem à parte Contratante</Text>.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 18 - ALTERAÇÃO DE INFORMAÇÕES ENDEREÇO DA CONTRATADA E DA PARTE CONTRATANTE.</Text> A
                                Contratada compromete-se a comunicar, por escrito impresso, mensagem do WhatsApp e (ou) pelo e-mail à parte Contratante
                                qualquer mudança de endereço, de telefone ou de e-mail. A parte Contratante deve informar as mesmas
                                alterações, se houver, à Contratada por escrito impresso, mensagem de WhatsApp ou em meio eletrônico (e-mail da Contratada
                                informado na primeira página deste contrato).
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO ÚNICO.</Text> Caso uma das partes não comunique a outra a referida alteração, 
                                serão conside- radas válidas as correspondências enviadas aos endereços constantes do presente instrumento, como entrega
                                dos boletos de pagamentos, Cartas de Cobrança, Cartas do SPC, SERASA e avisos em geral, inclusive para
                                efeito de citação judicial.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 19 - OBRIGAÇÕES DA CONTRATANTE.</Text> São obrigações da parte Contratante:
                            </Text>
                            <Text style={styles.textnormal}>
                                a) possuir equipamentos e softwares com acesso à internet e manter atualizado telefone e e-mail.
                            </Text>
                            <Text style={styles.textnormal}>
                                b) cadastrar o número da secretaria do curso em seu celular a fim de que possa receber as mensagens do
                                curso via Whatsapp.
                            </Text>
                            <Text style={styles.textnormal}>
                                c) zelar pela confidenciabilidade de seus códigos de acesso a cursos de forma a não permitir o
                                compartilhamento.
                            </Text>
                            <Text style={styles.textnormal}>
                                d) não reproduzir, sob qualquer forma o material do curso, sob pena de responder civil e criminalmente,
                                perante a Contratada e terceiros, nos termos da Lei nº. 9.609/98, por violação de propriedade intelectual,
                                devendo o uso deste ser feito exclusivamente em âmbito privado pelo Contratante.
                            </Text>
                            <Text style={styles.textnormal}>
                                e) seguir os padrões de conduta estabelecidos e vigentes na Internet, abstendo-se de: (i) violar a
                                privacidade de outros usuários; (ii) permitir que outras pessoas utilizem seu acesso ao ambiente de
                                treinamento; (iii) utilizar qualquer técnica de invasão ao site que viole a segurança do ambiente de
                                treinamento e de sites relacionados; (iv) agir conscientemente para destruir arquivos ou programas do
                                ambiente de treinamento e de sites relacionados; (v) utilizar os nomes e e-mails dos participantes do curso
                                para fins comerciais; (vi) enviar mensagens que possam ser consideradas obscenas e fora dos padrões
                                éticos e de bons costumes.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 20 - RESPONSABILIDADE DA PARTE CONTRATANTE POR DANOS CAUSADOS AO PATRIMÔNIO DA
                                    CONTRATADA e (OU) AO PATRIMÔNIO DE TERCEIROS OU A TERCEIROS OU DE TERCEIROS COM
                                    RELAÇÃO À PARTE CONTRATANTE. A Contratada não assume qualquer responsabilidade perante a
                                    parte Contratante e (ou) seu responsável legal/financeiro</Text> por quaisquer danos materiais ou
                                extramateriais ocasionados pela parte Contratante ao patrimônio da contratada e (ou) ao patrimônio de
                                terceiros ou a terceiros ou por terceiros à parte Contratante, por exemplo: se a parte Contratante ou
                                terceiros não observarem os enunciados normativos de segurança, das recomendações, instruções e
                                alertas de docentes, de instrutores e de funcionários técnicos administrativos, ou pela não utilização, ou
                                utilização inadequada de equipamentos de proteção individual, ou assemelhados, quando no exercício de
                                atividades acadêmicas que demandarem tal tipo de providência.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO - dano material à contratada e danos materiais e (ou) extramateriais aos
                                    docentes, aos funcionários da Contratada ou de terceiros por ela contratados.</Text> Em caso de dano
                                material ao patrimônio da Contratada ou de terceiros por ela contratados, ou de dano material e (ou)
                                extramaterial, respectivamente, aos docentes, aos funcionários da Contratada ou de terceiros por ela
                                contratados, a parte Contratante estará obrigada à reparação de tais danos, independentemente de dolo
                                ou culpa, e sem prejuízo da sanção disciplinar aplicável.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 21 - FORO DE ELEIÇÃO CONTRATUAL.</Text> Para dirimir questões oriundas do presente contrato, fica
                                eleito o foro da Circunscrição Judiciária de Brasília-DF. E por estarem justos e contratados, assinam o
                                presente instrumento em duas vias de igual teor e forma, para que se produzam todos os efeitos jurídicos.
                            </Text>
                            <Text style={styles.textnormal}>
                                <Text style={styles.textnegrito}>CGC 22 - CIÊNCIA DO CONTEÚDO CONTRATUAL.</Text> Neste ato, li, compreendi e assinei o conteúdo do
                                presente contrato, cujas dúvidas foram sanadas pela Contratada. Declaro ainda que, neste ato, recebi uma
                                via do presente Contrato.
                            </Text>
                            <Text style={styles.dataFinalContrato}>
                                Brasília, {moment().format('DD')} de {moment().format('MMMM')} de {moment().format('YYYY')}.
                            </Text>
                            <View style={styles.row}>
                                <View style={styles.signatureLine}>
                                    <Text style={styles.textnegrito}>________________________________________________</Text>
                                    <Text style={styles.signatureName}>{matriculaAluno.responsavel.pessoaResponsavel.nome}</Text>
                                </View>
                                <View style={styles.signatureLine}>
                                    <Text style={styles.textnegrito}>________________________________________________</Text>
                                    <Text style={styles.signatureName}>ACADEMIA DAS ESPECÍFICAS </Text>
                                    <Text style={styles.signatureName}>- GESTÃO EDUCACIONAL LTDA</Text>
                                </View>
                            </View>
                            <View style={styles.row}>
                                <View style={styles.signatureLine}>
                                    <Text style={styles.textnegrito}>________________________________________________</Text>
                                    <Text style={styles.signatureName}>Testemunha:</Text>
                                    <Text style={styles.signatureName}>Endereço:</Text>
                                    <Text style={styles.signatureName}>RG.:</Text>
                                    <Text style={styles.signatureName}>CPF:</Text>
                                </View>
                                <View style={styles.signatureLine}>
                                    <Text style={styles.textnegrito}>________________________________________________</Text>
                                    <Text style={styles.signatureName}>Testemunha:</Text>
                                    <Text style={styles.signatureName}>Endereço:</Text>
                                    <Text style={styles.signatureName}>RG.:</Text>
                                    <Text style={styles.signatureName}>CPF:</Text>
                                </View>
                            </View>
                        </View>
                        {possuiCheques() ? (
                            <>
                                <View style={styles.tableTitle} break><Text>Dados dos Cheques</Text></View>
                                <View style={styles.tableContainer}>
                                    <View style={styles.tableHeaderRow}>
                                        <View style={styles.tableHeaderCell}><Text>Dono do Cheque</Text></View>
                                        <View style={styles.tableHeaderCell}><Text>Banco</Text></View>
                                        <View style={styles.tableHeaderCell}><Text>Agência</Text></View>
                                        <View style={styles.tableHeaderCell}><Text>Conta</Text></View>
                                        <View style={styles.tableHeaderCell}><Text>Número do Cheque</Text></View>
                                        <View style={styles.tableHeaderCell}><Text>Data</Text></View>
                                        <View style={styles.tableHeaderCell}><Text>Valor</Text></View>
                                    </View>
                                    {(() => {
                                        const chequeDatas = getChequeDatas();
                                        const chequeValores = getChequeValores();
                                        const chequesOrdenados = getChequesOrdenados();
                                        return chequesOrdenados.map((cheque, index) => (
                                            <View key={index} style={styles.tableRow}>
                                                <View style={styles.tableCell}><Text>{cheque.nomeDonoCheque ?? ''}</Text></View>
                                                <View style={styles.tableCell}><Text>{cheque.banco ?? ''}</Text></View>
                                                <View style={styles.tableCell}><Text>{cheque.agencia ?? ''}</Text></View>
                                                <View style={styles.tableCell}><Text>{cheque.conta ?? ''}</Text></View>
                                                <View style={styles.tableCell}><Text>{cheque.numero?.toString() ?? ''}</Text></View>
                                                <View style={styles.tableCell}><Text>{chequeDatas[index] ?? ''}</Text></View>
                                                <View style={styles.tableCell}><Text>{chequeValores[index] ?? ''}</Text></View>
                                            </View>
                                        ));
                                    })()}
                                </View>
                            </>
                        ) : null}
                        {possuiCabineEstudoVIP() ? (
                            <>
                                <View style={styles.title} break><Text>ANEXO/ ADITIVO DE CONTRATO - USO ONEROSO DA CABINE DE ESTUDOS</Text></View>
                                <View style={styles.section}>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>CGC 23 (objeto): </Text>
                                        <Text style={styles.textnormal}>Uso oneroso da Cabine de Estudo VIP nº {matriculaAluno.numeroCabineVip?.toString()} nos períodos: Manhã, Tarde, Noite, 
                                            de {getDataContrato(matriculaAluno.dataInicioAula ?? new Date)} à {getDataContrato(matriculaAluno.dataFimAula ?? new Date)} na Sala de Estudos VIP disponibilizada pela <Text style={styles.textnegrito}>ACADEMIA DAS ESPECÍFICAS.</Text>
                                        </Text>
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>CGC 24. </Text>O uso oneroso da cabine terá o prazo iniciado e finalizado de acordo com o citado na CGC 2, com
                                        horários fixos e definidos na CLAÚSULA SEXTA desse contrato aditivo. O uso da cabine 
                                        é <Text style={styles.textnegrito}>individual</Text> e <Text style={styles.textnegrito}>intransferível</Text>, não podendo o 
                                        ALUNO sublocar, ceder, emprestar a Cabine VIP contratada de forma total
                                        e/ou parcial sob nenhuma hipótese.
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO: </Text>A locação compreenderá os dias de segunda à sábado, conforme horários
                                        predeterminados pelo Contratado.
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO SEGUNDO: </Text>Os espaços de estudos das Cabines VIPs, bem como a Academia das Específicas, estarão
                                        fechados nos feriados e recessos definidos em calendário escolar.
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>CGC 25 (do acesso e uso das cabines): </Text>Para acessar a sala das cabines, a parte Contratante deverá fazer
                                        a entrada por meio de controle biométrico digital;
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO: </Text>Após a finalização das horas contratadas em determinado turno, a parte
                                        Contratante deverá se retirar da cabine, sendo-lhe dado o prazo máximo de tolerância de 10 (dez)
                                        minutos para tal;
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO SEGUNDO: </Text>Caso seja observado que a parte Contratante liberou a entrada de pessoas não
                                        autorizadas ou esteja utilizando-se da cabine indevidamente, para outros fins que não o de estudo,
                                        independentemente de má-fé ou de situações semelhantes, <Text style={styles.textnegrito}>o serviço será cancelado sem devolução do
                                        valor investido;</Text>
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO TERCEIRO: </Text>Viagens e perı́odos de ausência da parte Contratante não serão ressarcidos ou
                                        compensados pela Contratada;
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO QUARTO: </Text>Não será permitido à parte Contratante o porte de armas de fogo ou arma branca
                                        de qualquer espécie dentro das instalações da Unidade da Contratada;
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO QUINTO: </Text>Para fins de manutenção do bem-estar, da higiene e da neutralidade olfativa do 
                                        ambiente de estudos, a parte CONTRATANTE não poderá: 
                                    </Text>
                                    <View style={{ marginLeft: 12 }}>
                                        <Text style={styles.textnormal}>1) Realizar refeições de qualquer natureza dentro da sala de estudos;</Text>
                                        <Text style={styles.textnormal}>2) Utilizar substâncias com odores fortes ou voláteis, tais como acetona, esmaltes, solventes, perfumes excessivos, sprays aerossóis ou produtos químicos similares;</Text>
                                        <Text style={styles.textnormal}>3) Praticar qualquer atividade que disperse odores que possam causar desconforto ou distração aos demais usuários.</Text>
                                    </View>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>CGC 26 (das obrigações do contratante): </Text>A parte CONTRATANTE compromete-se a manter silêncio absoluto no ambiente de estudos, observando as seguintes diretrizes: 
                                    </Text>
                                    <View style={{ marginLeft: 12 }}>
                                        <Text style={styles.textnormal}>1) É terminantemente proibida a realização de conversas, cochichos ou qualquer interação verbal dentro da sala, devendo o aluno se retirar do recinto para comunicações necessárias;</Text>
                                        <Text style={styles.textnormal}>2) O uso de dispositivos eletrônicos para assistir a vídeos, aulas, ouvir músicas ou áudios de qualquer natureza é condicionado obrigatoriamente ao uso de fones de ouvido, em volume que não gere vazamento sonoro para os demais usuários;</Text>
                                        <Text style={styles.textnormal}>3) O manuseio de materiais (folhear de livros, organização de estojos, etc.) e o consumo de água devem ser feitos de forma discreta, evitando ruídos excessivos;</Text>
                                        <Text style={styles.textnormal}>4) Dispositivos móveis devem permanecer em modo silencioso ou "não perturbe", sendo vedada a emissão de alertas sonoros ou vibrações sobre as mesas que possam causar distrações.</Text>
                                    </View>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO ÚNICO: </Text>Antes de se retirar das cabines, a parte Contratante deve verificar se não esqueceu
                                        nenhum pertence de valor (exemplo: celulares, tablets, notebook, dentre outros eletrônicos similares),
                                        material ou objeto, tendo em vista que a <Text style={styles.textnegrito}>Contratada não se responsabiliza</Text> por nenhum destes bens
                                        esquecidos ou deixados na cabine;
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>CGC 27 (das obrigações do contratado): </Text>Deverá a Contratada manter sempre o ambiente, bem como as
                                        cabines, limpos e higienizados para a utilização da parte Contratante;
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO PRIMEIRO: </Text>Deverá a Contratada informar com antecedência mı́nima de 48 horas (quarenta
                                        e oito horas) a programação dos horários da semana nos casos em que houver feriados ou pontos
                                        facultativos não contemplados em calendário escolar;
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO SEGUNDO: </Text>Deverá a Contratada sempre informar previamente à parte Contratante, por
                                        e-mail ou por WhatsApp, bem como deixar exposto no quadro de avisos, quando houver alguma mudança de horário.
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>CGC 28 (dos horários): </Text>Uso oneroso mensal, por período das 07h00 às 21h40.
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>CGC 29 (do pagamento): </Text>O valor de {getValorCabine()} ({matriculaAluno.valorCabineVipExtenso}) refere-se especificamente ao uso oneroso objeto deste contrato 
                                        e já está integralmente incluído no valor total estabelecido na CGC 3, não consistindo, portanto, em qualquer taxa ou custo adicional, 
                                        cujo pagamento será feito por: {matriculaAluno.formasPagamento}.
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>PARÁGRAFO ÚNICO: </Text>Em caso de falta de pagamento no vencimento, o aluno perderá eventuais descontos
                                        concedidos pela Contratada, com as consequências postas na CGC do contrato firmado entre as partes na
                                        CGC 13, parágrafo único.
                                    </Text>
                                    <Text style={styles.textnormal}>
                                        <Text style={styles.textnegrito}>CGC 30 (Acerca da resilição da relação contratual): </Text>Em caso de resilição da relação Contratual por
                                        vontade de uma ou das duas partes, aplica-se o disposto na CGC 11, parágrafo quarto do contrato entre as
                                        partes.
                                    </Text>
                                </View>
                            </>
                        ) : null}
                        <Text
                            style={styles.footer}
                            fixed
                            render={({ pageNumber, totalPages }) => `pág. ${pageNumber}/${totalPages}`}
                        />
                    </Page>
                    {gradeHoraria ? (() => {
                        const alunoEspecificaIds = getAlunoEspecificaIds();
                        const especificasSemGrade = getEspecificasSemGrade();
                        const horariosByGrupo: Record<string, HorarioDto[]> = { Manha: [], Tarde: [], Noite: [] };
                        for (const h of gradeHoraria.horarios) {
                            if (!horariosByGrupo[h.grupo]) horariosByGrupo[h.grupo] = [];
                            horariosByGrupo[h.grupo].push(h);
                        }

                        return (
                            <Page size="A4" style={styles.page}>
                                <View style={styles.logo}>
                                    <Image src={Logomarca} />
                                </View>

                                <View style={{ alignItems: 'center', marginBottom: 4 }}>
                                    <Text style={{ color: 'black', fontWeight: 'bold', fontSize: 14, fontFamily: 'Cambria', textDecoration: 'underline' }}>
                                        {(matriculaAluno.unidade?.nome ?? '').toUpperCase()}
                                    </Text>
                                </View>

                                <View style={{ alignItems: 'center', marginBottom: 4 }}>
                                    <Text style={{ color: 'black', fontWeight: 'bold', fontSize: 12, fontFamily: 'Cambria' }}>
                                        {gradeHoraria.turmaNome}
                                    </Text>
                                </View>

                                {gradeHoraria.turmaPeriodoLetivoDataInicio ? (
                                    <View style={{ alignItems: 'center', marginBottom: 2 }}>
                                        <Text style={{ fontSize: 10, fontFamily: 'Cambria', color: 'black' }}>
                                            (Prevão de Início para {gradeHoraria.turmaPeriodoLetivoDataInicio})
                                        </Text>
                                    </View>
                                ) : null}
                                {gradeHoraria.turmaPeriodoLetivoDataFim ? (
                                    <View style={{ alignItems: 'center', marginBottom: 10 }}>
                                        <Text style={{ fontSize: 10, fontFamily: 'Cambria', color: 'black' }}>
                                            (Prevão de Fim para {gradeHoraria.turmaPeriodoLetivoDataFim})
                                        </Text>
                                    </View>
                                ) : null}

                                {/* Tabela 1 — grade filtrada pelas específicas contratadas */}
                                <View style={styles.gradeTable}>
                                    <View style={styles.gradeHeaderRow}>
                                        <View style={[styles.gradeHeaderCell, styles.gradeCellHorario]}>
                                            <Text> </Text>
                                        </View>
                                        {DIAS_ORDER.map(dia => (
                                            <View key={dia} style={styles.gradeHeaderCell}>
                                                <Text>{DIAS_LABELS[dia]}</Text>
                                            </View>
                                        ))}
                                    </View>
                                    {GRUPO_ORDER.filter(g => (horariosByGrupo[g] ?? []).length > 0).map(grupo => (
                                        <View key={grupo}>
                                            <View style={styles.gradeGroupRow}>
                                                <Text style={styles.gradeGroupLabel}>{GRUPO_LABELS[grupo]}</Text>
                                            </View>
                                            {[...(horariosByGrupo[grupo] ?? [])]
                                                .sort((a, b) => a.ordem - b.ordem)
                                                .map((horario, idx) => (
                                                    <View key={horario.id ?? idx} style={[styles.gradeRow, idx % 2 === 0 ? styles.gradeRowEven : {}]}>
                                                        <View style={[styles.gradeCell, styles.gradeCellHorario]}>
                                                            <Text style={styles.gradeCellText}>{horario.horaInicio}-{horario.horaFim}</Text>
                                                        </View>
                                                        {DIAS_ORDER.map(dia => {
                                                            const aula = horario.aulas.find(
                                                                a => a.diaSemana === dia && alunoEspecificaIds.has(a.especificaId)
                                                            );
                                                            return (
                                                                <View key={dia} style={styles.gradeCell}>
                                                                    <Text style={styles.gradeCellText}>{aula ? aula.especificaNome : '-'}</Text>
                                                                </View>
                                                            );
                                                        })}
                                                    </View>
                                                ))
                                            }
                                        </View>
                                    ))}
                                </View>

                                {/* Tabela 2 — específicas contratadas sem horário na grade */}
                                {especificasSemGrade.length > 0 ? (
                                    <View style={{ marginTop: 14 }}>
                                        <View style={styles.gradeTable}>
                                            <View style={styles.gradeHeaderRow}>
                                                <View style={styles.gradeHeaderCell}>
                                                    <Text>Dia a definir</Text>
                                                </View>
                                                <View style={styles.gradeHeaderCell}>
                                                    <Text>Dia a definir</Text>
                                                </View>
                                                <View style={[styles.gradeHeaderCell, { borderRightWidth: 0 }]}>
                                                    <Text> </Text>
                                                </View>
                                            </View>
                                            <View style={styles.gradeRow}>
                                                <View style={styles.gradeCell}>
                                                    <Text style={[styles.gradeCellText, { fontWeight: 'bold' }]}>Horário a definir</Text>
                                                </View>
                                                <View style={styles.gradeCell}>
                                                    <Text style={styles.gradeCellText}>
                                                        {especificasSemGrade.map(d => d.nome).join(', ')}
                                                    </Text>
                                                </View>
                                                <View style={[styles.gradeCell, { borderRightWidth: 0 }]}>
                                                    <Text> </Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                ) : null}

                                {/* Rodapé — aviso WhatsApp + telefone da unidade */}
                                <View style={styles.gradePhoneFooter}>
                                    <Text style={{ fontSize: 9, fontFamily: 'Cambria', color: 'black', marginBottom: 4 }}>
                                        {'Toda nossa comunicação é feita com o aluno via "Comunidade" no Whatsapp.'}
                                    </Text>
                                    <Text style={{ fontSize: 9, fontFamily: 'Cambria', color: 'black', marginBottom: 8 }}>
                                        {'É extremamente importante que o aluno não saia da comunidade para não perder nenhuma informação importante referente ao curso.'}
                                    </Text>
                                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <Image src={WhatsappIcon} style={{ width: 14, height: 14, marginRight: 5 }} />
                                        <Text style={{ fontWeight: 'bold', fontSize: 10, fontFamily: 'Cambria', color: 'black' }}>
                                            {mascaraCelular(matriculaAluno.unidade?.telefone ?? '')}
                                        </Text>
                                    </View>
                                </View>
                            </Page>
                        );
                    })() : null}
                </Document>
            </PDFViewer>
        </>
    );
};